<template>   
    <div @click="examplesClose" class="examples-mask">
        <van-dialog v-model="show" class="examples-box" :showConfirmButton="false" v-if="credentialsData.name">
                <img class="examples-box-close" src="@/assets/images/iconClose.png" @click="examplesClose" />
                    <div class="examples-box-main">
                        <div class="examples-box-title">
                            {{credentialsData.name == '身份证上传' ? '身份证人像面' : '驾驶证首页'}}
                        </div>
                        <div class="main_box_b">
                            <div class="examples-box-main_box">
                                <div class="examples-box-img" :style="{
                                    backgroundImage: 'url('+credentialsData.examplesFrontUrl + ')',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: '100%',
                                    }">
                                </div>
                            </div>
                        </div>
                        <div class="examples-box-title">
                            {{credentialsData.name == '身份证上传' ? '身份证国徽面' : '驾驶证副页'}}
                        </div>
                        <div class="main_box_b">
                            <div class="examples-box-main_box">
                                <div class="examples-box-img" :style="{
                                    backgroundImage: 'url('+credentialsData.examplesBackUrl + ')',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: '100%',
                                    }">
                                </div>
                            </div>
                        </div>
                </div>
        </van-dialog>
    </div>
</template>

<script>
// 身份证和驾驶证信息组件
export default {
  name: 'ExamplesImg',
  props:{
    credentialsData:{
        type: Object,
        default: ()=>{
            return {
                
            }
        }
    },
    show:{
        type:Boolean,
        default:false
    },
  },
  data() {
    return{
       
    }
  },
  methods:{
      //关闭示例
      examplesClose(){
          this.$emit("examplesClose");
      }
  }
}
</script>
<style lang='less' scoped>
.examples-mask{
  padding-bottom: 20px;
}
.examples-box{
    width: 90%;
    background: none;
    padding-top: 100px;
    .examples-box-close{
        width: 40px;
        height: 40px;
        position: absolute;
        top: 120px;
        right: 40px;
    }
    .examples-box-title{
        font-family: PingFangSC-Medium;
        font-size: 50px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        font-weight: bold;
        margin-top:44px;
        margin-bottom:38px;
    }
    .main_box_b{
        position: relative;
        ::before{
            display: block;
            content:'';
            width: 28px;
            height: 28px;
            position: absolute;
            left: -20px;
            top: -20px;
            transform: rotate(-180deg);
            border-right: 4px solid #176AF0;
            border-bottom: 4px solid #176AF0;
        }
        ::after{
            display: block;
            content:'';
            width: 28px;
            height: 28px;
            position: absolute;
            right: -20px;
            top: -20px;
            transform: scaleY(-1);
            border-right: 4px solid #176AF0;
            border-bottom: 4px solid #176AF0;
        }
    }
    .examples-box-main_box{
        position: relative;
        ::before{
            display: block;
            content:'';
            width: 28px;
            height: 28px;
            position: absolute;
            left: -20px;
            top: 372px;
            transform: rotate(90deg);
            border-right: 4px solid #176AF0;
            border-bottom: 4px solid #176AF0;
        }
        ::after{
            display: block;
            content:'';
            width: 28px;
            height: 28px;
            position: absolute;
            right: -20px;
            top: 372px;
            transform: scaleY(1);
            border-right: 4px solid #176AF0;
            border-bottom: 4px solid #176AF0;
        }
    }
    .examples-box-main{
        margin-bottom:50px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .examples-box-img{
        width: 625px;
        height: 382px;
        border-radius: 10px;
        margin-bottom: 56px;
    }
}
</style>
